import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from '../TaskDetails.style';
import {TaskDetailsContent} from '../TaskDetailsContent';

export const WelcomeMessageTaskDetails = () => {
  const {ts} = useTranslation(
    'clientProfile.clientJourney.preJourney.welcomeMessage',
  );

  return (
    <>
      <View style={styles.taskDetailContents}>
        <Text {...testProperties(DownlineProfile.cjTaskDetailsText)}>
          {ts(
            'welcomemessagedetails',
            "Direct your Client to their Welcome Message and review some items they'll need to pick up for when they start:",
          )}
        </Text>
      </View>

      <TaskDetailsContent
        taskDetailsList={[
          ts('detailsListItem1', 'A | food scale | to weigh lean protein.'),
          ts(
            'detailsListItem2',
            'A | digital scale | to track their progress.',
          ),
          ts(
            'detailsListItem3',
            'A | measuring tape | to track their waist, arm, thigh, chest, & hip sizes.',
          ),
        ]}
        style={{
          // @ts-expect-error TS(2339): Property 'preJourneyListItem' does not exist on ty... Remove this comment to see the full error message
          listItem: styles.preJourneyListItem,
        }}
      />
    </>
  );
};
